/**
 * ThumbHash → data-URL decode (FEAT-012 blur placeholders).
 * Memoized per hash: a grid re-render must not re-decode 50 images.
 */

import { thumbHashToDataURL } from 'thumbhash';

const cache = new Map<string, string>();

/** The raw hash bytes, or null if the string isn't base64. Shared with mediaFit. */
export function thumbhashBytes(hash: string | null | undefined): Uint8Array | null {
  if (!hash) return null;
  try {
    return Uint8Array.from(atob(hash), (c) => c.charCodeAt(0));
  } catch {
    return null;
  }
}

export function thumbhashUrl(hash: string | null | undefined): string | null {
  if (!hash) return null;
  const cached = cache.get(hash);
  if (cached) return cached;
  const bytes = thumbhashBytes(hash);
  if (!bytes) return null;
  try {
    const url = thumbHashToDataURL(bytes);
    cache.set(hash, url);
    return url;
  } catch {
    return null;
  }
}
